<template>
  <div class="introduce">
    <div class="banner">
      <p>公司介绍</p>
      <p>让你更安心、更放心、更省心</p>
    </div>
    <div class="head">
      <div class="en-title">Complete the developed product through code</div>
      <div class="chs-title">研发的产品</div>
    </div>
    <div class="product">
      <div class="item" v-for="(item, index) in items" :key="index">{{ item }}</div>
    </div>

    <div class="head">
      <div class="en-title">Operational capability map</div>
      <div class="chs-title">运营能力</div>
    </div>

    <div class="operational"></div>

    <div class="head">
      <div class="en-title">Team introduction</div>
      <div class="chs-title">团队介绍</div>
    </div>

    <div class="table1"></div>
    <div class="table2"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      items: ["管 理 系 统 (C/S)", "电 商 系 统", "电 商 网 站", "积 分 商 城 系 统", "销 售 管 理 系 统", "招 聘 网 站", "众 包 网 站", "OA 管 理 系 统", "点 餐 系 统", "微 信 商 城 ", "班 车 小 程 序", "电 商 小 程 序 ", "家 具 小 程 序", "农 鲜 配 送 app", "叫 车 软 件", "直 播 类 app"],
    }
  },
  created() {},
  methods: {},
}
</script>

<style scoped lang="less">
.introduce {
  min-height: calc(100vh - 61px - 150px);
  .banner {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 374px;
    color: #fff;
    text-align: center;
    background: url("../assets/introduce.png") no-repeat;
    background-size: cover;
    margin-bottom: 120px;
    p:first-child {
      font-size: 42px;
    }
    p:last-child {
      font-size: 30px;
    }
  }
  .head {
    width: 1520px;
    margin: 0 auto 60px;
  }
  .product {
    display: grid;
    grid-template-columns: repeat(4, 352px);
    grid-gap: 16px;
    width: 1520px;
    margin: 0 auto 120px;
    padding: 30px;
    border: 1px solid #0861cc;
    border-radius: 4px;
    box-sizing: border-box;
    .item {
      color: #0861cc;
      font-size: 30px;
      font-weight: bold;
      background-color: #e6effa;
      text-align: center;
      padding: 20px 0;
      border-radius: 4px;
      box-sizing: border-box;
      transition: 0.25s;
      cursor: pointer;
      &:hover {
        color: #fff;
        background-color: #0861cc;
      }
    }
  }
  .operational {
    width: 1520px;
    height: 930px;
    margin: 0 auto 100px;
    background: url("../assets/operate.png") no-repeat;
    background-size: cover;
  }
  .table1 {
    width: 1520px;
    height: 600px;
    margin: 0 auto 100px;
    background: url("../assets/table1.png") no-repeat;
    background-size: cover;
  }
  .table2 {
    width: 1520px;
    height: 600px;
    margin: 0 auto 100px;
    background: url("../assets/table2.png") no-repeat;
    background-size: cover;
  }
}
</style>
